import { useEffect } from "react";

function ensureDescriptionTag() {
  let tag = document.querySelector('meta[name="description"]');

  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute("name", "description");
    document.head.appendChild(tag);
  }

  return tag;
}

export default function useDocumentMeta({ title, description }) {
  useEffect(() => {
    const previousTitle = document.title;
    const descriptionTag = ensureDescriptionTag();
    const previousDescription = descriptionTag.getAttribute("content");

    if (title) {
      document.title = title;
    }

    if (description) {
      descriptionTag.setAttribute("content", description);
    }

    return () => {
      document.title = previousTitle;

      if (previousDescription) {
        descriptionTag.setAttribute("content", previousDescription);
      }
    };
  }, [title, description]);
}
